/** Which of a person's identity documents on a fund-opening request is being replaced. */
export enum OpenFundRequestDocumentSlot {
  IdCard = 'IdCard',
  IdAppendix = 'IdAppendix',
}
